import { ALLOCATIONS_ROLES } from "@/constants/appRoles";
import { LucideIcon, Table, Users } from "lucide-react";

export interface SidebarItem {
  title: string;
  url: string;
  icon: LucideIcon;
  requiredRoles?: readonly string[];
}

export const sidebarItems: SidebarItem[] = [
  // {
  //   title: "Home",
  //   url: "/",
  //   icon: Home,
  // },
  // {
  //   title: "Search",
  //   url: "/search",
  //   icon: Search,
  // },
  {
    title: "Pipeline",
    url: "/pipeline",
    icon: Table,
  },
  {
    title: "Allocations",
    url: "/allocations",
    icon: Users,
    requiredRoles: ALLOCATIONS_ROLES,
  },
];
